import React from "react";
import { useMediaQuery } from "react-responsive";
import AdminDashboard from "../components/AdminDashboard/AdminDashboard";
import MobileAdminDashboard from "../mobileComponent/MobileAdminDashboard/MobileAdminDashboard";

function AdminDashbd() {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 501px)",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 500px)" });
  return (
    <>
      {isDesktopOrLaptop && <AdminDashboard />}
      {isTabletOrMobile && <MobileAdminDashboard />}
    </>
  );
}

export default AdminDashbd;
